export default class ActualizarPerfilCurso {
  #repository
  constructor(repository) {
    this.#repository = repository
  }
  async execute(idPerfilCurso, payload) {
    try {
      const result = await this.#repository.actualizarPerfilCurso(idPerfilCurso, payload)
      return result
    } catch (error) {
      throw error
    }
  }
}
